import React from 'react';

const QuickBooksVersion = () => (
    <div>
        <div className="sectionQuestion">
            Which versions of QuickBooks&trade; does Minute7 Work With?
        </div>
        <div className="sectionAnswer">
            Minute7 integrates with:
            <ul>
                <li>QuickBooks Online: Essentials, Plus, and Advanced.</li>
                <li>QuickBooks Desktop: All currently supported versions</li>
            </ul>
            <span>
                <b>Important:</b> QuickBooks Online Simple Start does not support third-party time
                tracking integrations due to limitations set by Intuit, and therefore cannot be used
                with Minute7.
            </span>
        </div>
    </div>
);
export default QuickBooksVersion;
